import {APIService} from "../../common/APIService";
import {Workorder} from "../../dto/Workorder";

export class WorkorderService extends APIService {
  public async browse(): Promise<Workorder[]> {
    const json = await this.getJson<{data: object[]}>(`workorders`)
    return json.data.map(item => Workorder.fromJson(item))
  }

  public async getWorkorders(date: Date): Promise<Workorder[]> {
    const json = await this.getJson<{ data: object[] }>(`workorders?date=${Math.floor(date.getTime() / 1000)}`)
    return json.data.map(item => Workorder.fromJson(item))
  }
}